export default __webpack_public_path__ + "static/media/glasses.f477cf1c.svg";